import { Http, Headers, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";

import { Candidato } from "./candidato";
import { SessionService } from "./../session/session.service";
import { environment } from "../../../environments/environment";
import { ProcessoService } from "./../processo/processo.service";
import { HeaderService } from "./../http/header.service";
import { DocumentoGlobal } from "./../documento/documento-global";

@Injectable()
export class CandidatoService {
  constructor(
    private http: Http,
    private SessionService: SessionService,
    private ProcessoService: ProcessoService,
    private HeaderService: HeaderService,
    private DocumentoGlobal: DocumentoGlobal
  ) { }

  getCandidato(): Candidato {
    const candidato = this.SessionService.getValor("candidato");
    if (candidato) {
      return JSON.parse(candidato);
    }
    return null;
  }

  setCandidato(candidato: Candidato) {
    this.SessionService.setValor("candidato", JSON.stringify(candidato));
  }

  salvaCandidato(ensino, conclusao, declaracao, periodoEnsino) {
    const headers = this.HeaderService.getHeadersGnx();

    if (headers) {
      const curso_selecionado = JSON.parse(
        this.SessionService.getValor("cursoSelecionado")
      );

      return this.http
        .post(
          environment.apiGxUrl + "/prcpessoacandidato.svc/rest/",
          {
            PrcCdtDtEnsMed: conclusao,
            PrcCdtInsEnsMed: ensino,
            PrcCdtEnsMedCon: declaracao,
            PrcTipCod: this.ProcessoService.getTipoProcesso(),
            PrcOcoSeq: curso_selecionado.PrcOcoSeq,
            PrcSerieEM: periodoEnsino,
          },
          { headers: headers }
        )
        .map((res) => res.json())
        .catch((err: any) => {
          return Observable.throw(new Error(err.json()));
        });
    }
  }

  salvaDadosCandidato(candidato: Candidato) {
    const headers = this.HeaderService.getHeadersGnx();

    if (headers) {
      const curso_selecionado = JSON.parse(
        this.SessionService.getValor("cursoSelecionado")
      );

      const processo_selecionado = this.ProcessoService.getProcessoSeletivoSelecionado();

      return this.http
        .post(
          environment.apiGxUrl + `/rest/prcinscricao/,${processo_selecionado.PrcLetAno},${processo_selecionado.PrcLetSem},${this.ProcessoService.getTipoProcesso()},${curso_selecionado.PrcOcoSeq},${curso_selecionado.PrcOfeSeq},${candidato.bolsa},${candidato.mediaCandidato > 0 ? candidato.mediaCandidato : 0}`,
          {
            PrcLetAno: processo_selecionado.PrcLetAno,
            PrcLetSem: processo_selecionado.PrcLetSem,
            PrcTipCod: this.ProcessoService.getTipoProcesso(),
            PrcOcoSeq: curso_selecionado.PrcOcoSeq,
            PrcOfeSeq: curso_selecionado.PrcOfeSeq,
            PrcCdtEnemNum: candidato.PrcCdtEnemNum,
            PrcCdtEnemAno: candidato.PrcCdtEnemAno,
            PrcBolsa: candidato.bolsa,
            PrcInsCod: candidato.instrumento,
            PrcCdtMed: Number(candidato.mediaCandidato > 0) ? candidato.mediaCandidato : 0,
          },
          { headers: headers }
        )
        .map((res) => res.json())
        .catch((err: any) => {
          return Observable.throw(err.json());
        });
    }
  }

  deleteCandidatoCancelado(candidato: Candidato, cursoSelecionado: any) {
    const headers = this.HeaderService.getHeadersGnx();
    const processoSelecionado = this.ProcessoService.getProcessoSeletivoSelecionado();

    const body = {
      PrcCdtCod: Number(candidato.PrcCdtCod),
      PrcLetAno: processoSelecionado.PrcLetAno,
      PrcLetSem: processoSelecionado.PrcLetSem,
      PrcTipCod: processoSelecionado.PrcTipCod,
      PrcOcoSeq: cursoSelecionado.PrcOcoSeq,
      PrcOfeSeq: cursoSelecionado.PrcOfeSeq
    };

    return this.http.post(environment.apiGxUrl + '/WsPrcVerDel.svc/rest/', body, { headers: headers })
      .map((response: any) => response)
      .catch((err: any) => {
        return Observable.throw(err.json());
      });
  }

  getChangeDocumentos() {
    const changeDocumentos = this.SessionService.getValor("changeDocumentos");
    if (changeDocumentos) {
      return JSON.parse(changeDocumentos);
    }
    return true;
  }

  setChangeDocumentos(valor) {
    this.SessionService.setValor("changeDocumentos", JSON.stringify(valor));
  }

  getDocumentosCandidato() {
    const documentosCandidato = this.SessionService.getValor(
      "documentosCandidato"
    );
    if (documentosCandidato) {
      return JSON.parse(documentosCandidato);
    }
    return null;
  }

  setDocumentosCandidato(documentosCandidato) {
    this.setChangeDocumentos(false);
    this.SessionService.setValor(
      "documentosCandidato",
      JSON.stringify(documentosCandidato)
    );
  }

  getTodosDocumentos(TipDocCod = 0): Observable<any> {
    const headers = this.HeaderService.getHeadersGnx();

    const processo = this.ProcessoService.getProcessoSeletivoSelecionado();
    const curso = JSON.parse(this.SessionService.getValor("cursoSelecionado"));

    if (headers && processo) {
      return this.http
        .post(
          environment.apiGxUrl + "/wsdocumentoscandidato.svc/rest/",
          {
            PrcLetAno: processo.PrcLetAno,
            PrcLetSem: processo.PrcLetSem,
            PrcTipCod: this.ProcessoService.getTipoProcesso(),
            PrcOcoSeq: curso.PrcOcoSeq,
            TipDocCod: TipDocCod,
          },
          { headers: headers }
        )
        .map((res: Response) => {
          const response = res.json();
          return response.SdtPrcCandidato.PrcDocumentos;
        })
        .catch((err: any) => {
          return Observable.throw(new Error(err.json()));
        });
    }
  }

  isStricto() {
    let PrcTipPrc = sessionStorage.getItem("PrcTipPrc");
    return PrcTipPrc == "M" || PrcTipPrc == "D" || PrcTipPrc == "MD";
  }
}



// WEBPACK FOOTER //
// ./src/app/_shared/candidato/candidato.service.ts